import { render, staticRenderFns } from "./LocationShifts.vue?vue&type=template&id=109b2288"
import script from "./LocationShifts.vue?vue&type=script&lang=ts"
export * from "./LocationShifts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports